module.exports = __webpack_public_path__ + "static/media/teams3.628bfc8c.jpg";